import React from "react";
import { setInfoKey, removeInfoKey } from '../../api/information-collection/actions'
import CurrencyFormat from 'react-currency-format';
import { Tooltip,getPersonAgeByContractDate, getPersonTypeByAge, getContractStartDate } from '../../utils'
import StartDateOptions from '../start-date-options'
import InsuranceTaker from '../insurance-taker'

const kennitala = require('kennitala')

class RisForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                disabilitybenefits: '',
                hospitaldaily: '',
                deathbenefits: '',
                monthlypension: '',
                insurancetaker: '',
                riskGroup: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.age = React.createRef()
        this.disabilitybenefits = React.createRef()
        this.hospitaldaily = React.createRef()
        this.deathbenefits = React.createRef()
        this.monthlypension = React.createRef()
        this.insurancetaker = React.createRef()
    }

    componentDidMount () {
        if (this.props.initialValues['RIScontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "RIScontractstartdate", value: getContractStartDate("RIS").format("D.M.YYYY")}, this.props.customerId))
        }

        let info = kennitala.info(this.props.customerId)
        if (info.age > 17) {
            this.props.dispatch(setInfoKey({key: "RISinsuranceTaker", value: this.props.customerId}, this.props.customerId))
        } else {
            this.props.dispatch(setInfoKey({key: "RISriskgroup", value: "A"}, this.props.customerId))
        }
    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 0) {
                        errors.age = 'Að lágmarki 0'
                        valid = false;
                    } else if (parseInt(ageValue) > 80) {
                        errors.age = 'Að hámarki 80'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'disabilitybenefits':
                    let disabilitybenefitsValue = this.props.initialValues["RISdisabilitybenefits"];
                    if (parseInt(disabilitybenefitsValue) > 250000) {
                        errors.disabilitybenefits = 'Að hámarki 250.000 €'
                        valid = false;
                    } else if (parseInt(disabilitybenefitsValue) < 20000) {
                        errors.disabilitybenefits = 'Að lágmarki 20.000 €'
                        valid = false;
                    } else if (disabilitybenefitsValue === '' || disabilitybenefitsValue == undefined) {
                        errors.disabilitybenefits = 'Skilyrði að fylla út';
                        valid = false
                    } else {
                        errors.disabilitybenefits = ''
                    }
                    break;
                case 'hospitaldaily':
                        let hospitaldailyValue = this.props.initialValues["RIShospitaldaily1to3"];
                        if (parseInt(hospitaldailyValue) > 75) {
                            errors.hospitaldaily = 'Að hámarki 75 €'
                            valid = false;
                        } else if (parseInt(hospitaldailyValue) < 5 && parseInt(hospitaldailyValue) !== 0) {
                            errors.hospitaldaily = 'Að lágmarki 5 €'
                            valid = false;
                        } else {
                            errors.hospitaldaily = ''
                        }
                        break;
                case 'deathbenefits':
                        let deathbenefitsValue = parseInt(this.props.initialValues["RISdeathbenefits"]);
                        if (deathbenefitsValue > 250000) {
                            errors.deathbenefits = 'Að hámarki 250.000 €'
                            valid = false;
                        } else if (deathbenefitsValue < 1000 && deathbenefitsValue !== 0) {
                            errors.deathbenefits = 'Að lágmarki 1.000 €'
                            valid = false;
                        } else {
                            errors.deathbenefits = ''
                        }
                        break;
                case 'monthlypension':
                        let monthlypensionValue = this.props.initialValues["RISmonthlypension"];
                        if (parseInt(monthlypensionValue) > 3000) {
                            errors.monthlypension = 'Að hámarki 3.000 €'
                            valid = false;
                        } else if (parseInt(monthlypensionValue) < 250 && parseInt(monthlypensionValue) !== 0) {
                            errors.monthlypension = 'Að lágmarki 250 €'
                            valid = false;
                        } else {
                            errors.monthlypension = ''
                        }
                        break;
                
                case 'insurancetaker':
                    let insuranceTakerValue = this.props.initialValues['RISinsuranceTaker'];
                    if (insuranceTakerValue === undefined || insuranceTakerValue === "") {
                        errors.insurancetaker = 'Velja þarf tryggingartaka'
                        valid = false;
                    } else {
                        errors.insurancetaker = ''
                    }
                    break;

                case 'riskGroup':
                    let riskGroupValue = this.props.initialValues['RISriskgroup'];
                    if (riskGroupValue === undefined || riskGroupValue === "") {
                        errors.riskGroup = 'Velja þarf áhættuhóp'
                        valid = false;
                    } else {
                        errors.riskGroup = ''
                    }
                    break;

                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.checked }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeLargeNumberInput(value, name) {
        if ((event.target.name === "RIShospitaldaily1to3" || event.target.name === "RISdeathbenefits" || event.target.name === "RISmonthlypension") && (event.target.value === "" || event.target.value === "0")) {
            this.props.dispatch(removeInfoKey(event.target.name, this.props.customerId))
        } else {
            this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
        }
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }
    
    onClickConfirm(event) {
        let validate = this.validateForm()

        if (this.props.isAdult && this.props.initialValues['RISinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'RISinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }
        
        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    render() {
        const { customerId, customers, active, initialValues } = this.props
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["RIScontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        let RIShospitaldaily4 = 0
        if (initialValues["RIShospitaldaily1to3"]) {
            RIShospitaldaily4 = parseInt(initialValues["RIShospitaldaily1to3"])*2
        }

        let RISfivefoldbenefits = 0
        if (initialValues["RISdisabilitybenefits"]) {
            RISfivefoldbenefits = 5* parseInt(initialValues["RISdisabilitybenefits"])
        }

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                 <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input id={`ris-contract-age-${customerId}`} name="contract-age" type="number" className="form-control px-2 text-sm-right" value={displayAge} />
                            <input type="hidden" ref={this.age} id={`ris-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={initialValues["age"]} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <StartDateOptions
                                startDate={getContractStartDate("RIS").format("D.M.YYYY")}
                                selectedDate={initialValues["RIScontractstartdate"]}
                                contractDateKey={"RIScontractstartdate"}
                                customerId={customerId}
                                disabled={initialValues.risConfirm}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                    <div  className={`${this.state.errors.riskGroup.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <div className="col-sm-6">
                            <label className="mr-5" htmlFor={`risk-group-${customerId}`}>
                                Áhættuhópur:
                                {this.state.errors.riskGroup.length > 0 ?
                                 <span className="error"> ({this.state.errors.riskGroup}) </span> : ''
                                }
                            </label>
                        </div>
                        <div className="col-sm-6 text-right">
                            <select className="custom-select col-sm-4" id={`risk-group-${customerId}`} name="RISriskgroup" onChange={this.onChangeSelectValue} value={initialValues["RISriskgroup"]} disabled={initialValues.risConfirm || getPersonTypeByAge(customerId) === "child"} >
                                <option value="">Veldu áhættuhóp</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-12">Eftir 3 ár framlengist samningur alltaf um 1 ár</div>
                        <div className="col-sm-12">Upphæðir í EUR</div>
                    </div>

                    <div className={`${this.state.errors.disabilitybenefits.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`disability-benefits-${customerId}`} className="col-sm-8 col-form-label">
                            Upphæð örorkubóta
                            {this.state.errors.disabilitybenefits.length > 0 ?
                                 <span className="error"> ({this.state.errors.disabilitybenefits}) </span> : ''
                            }
                        </label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat
                                ref={this.disabilitybenefits}
                                thousandSeparator={"."} 
                                id={`disability-benefits-${customerId}`} 
                                name="RISdisabilitybenefits"
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={initialValues["RISdisabilitybenefits"]} 
                                disabled={initialValues.risConfirm}
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.onChangeLargeNumberInput(value, "RISdisabilitybenefits")
                                }}
                            />
                            20.000 til 250.000 EUR
                        </div>
                    </div>
                    
                    <div className="form-row align-items-center">
                        <label htmlFor={`RISfivefoldbenefits-benefits-${customerId}`} className="col-sm-8 col-form-label">Allt að fimmfaldar örorkubætur</label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat 
                                thousandSeparator={"."} 
                                id={`RISfivefoldbenefits-benefits-${customerId}`}
                                name="RISfivefoldbenefits"
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={RISfivefoldbenefits}
                                disabled
                                decimalSeparator={','} 
                            />
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="py-sm-0 py-2 col-sm-6 addon-insurance">
                            <label className="caption-label" htmlFor={`ris-additional-protection-${customerId}`}>Viðbótarvernd</label>
                            <input type="checkbox" id={`ris-additional-protection-${customerId}`} name='RISadditionalprotection' onChange={this.onChangeCheckbox} checked={initialValues["RISadditionalprotection"]} disabled={initialValues.risConfirm} />
                            <label htmlFor={`ris-additional-protection-${customerId}`}></label>
                        </div>
                        <div className="py-sm-0 py-2 col-sm-6 addon-insurance">
                            <label className="caption-label" htmlFor={`emergency-benefits-${customerId}`}>Bráðabætur</label>
                            <input type="checkbox" id={`emergency-benefits-${customerId}`} name='RISemergencybenefits' onChange={this.onChangeCheckbox} checked={initialValues["RISemergencybenefits"]} disabled={initialValues.risConfirm} />
                            <label htmlFor={`emergency-benefits-${customerId}`}></label>
                        </div>
                    </div>

                    <div className={`${this.state.errors.hospitaldaily.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`hospital-daily-1-3-${customerId}`} className="col-sm-8 col-form-label">
                            Sjúkrahús dagp. 1-3 dagar
                            {this.state.errors.hospitaldaily.length > 0 ?
                                 <span className="error"> ({this.state.errors.hospitaldaily}) </span> : ''
                            }
                        </label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat
                                ref={this.hospitaldaily}
                                thousandSeparator={"."} 
                                id={`hospital-daily-1-3-${customerId}`}
                                name="RIShospitaldaily1to3"
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={initialValues["RIShospitaldaily1to3"]} 
                                disabled={initialValues.risConfirm}
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.onChangeLargeNumberInput(value, "RIShospitaldaily1to3")
                                }}
                            />
                            5-75 €
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <label htmlFor={`hospital-daily-4-${customerId}`} className="col-sm-8 col-form-label">Sjúkrahús dagp. frá 4.degi</label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat 
                                thousandSeparator={"."} 
                                id={`hospital-daily-4-${customerId}`}
                                name="RIShospitaldaily4"
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={RIShospitaldaily4}
                                disabled
                                decimalSeparator={','} 
                            />
                        </div>
                    </div>

                    <div className={`${this.state.errors.deathbenefits.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-death-benefits-${customerId}`} className="col-sm-8 col-form-label">
                            Dánarbætur vegna slyss
                            {this.state.errors.deathbenefits.length > 0 ?
                                 <span className="error"> ({this.state.errors.deathbenefits}) </span> : ''
                            }
                        </label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat
                                ref={this.deathbenefits}
                                thousandSeparator={"."} 
                                id={`ris-death-benefits-${customerId}`} 
                                name="RISdeathbenefits" 
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={initialValues["RISdeathbenefits"]} 
                                disabled={initialValues.risConfirm}
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    var {value} = values;
                                    this.onChangeLargeNumberInput(value, "RISdeathbenefits")
                                }}
                                onBlur={(e) => {
                                    var value = e.target.value.replace(".", "")
                                    if (parseInt(value)>=1000) {
                                        value = Math.round(value/1000)*1000
                                    }
                                    this.onChangeLargeNumberInput(value, "RISdeathbenefits")
                                }}
                            />
                            1.000-250.000 € (hlaupa á þúsundum)
                        </div>
                    </div>

                    <div className={`${this.state.errors.monthlypension.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-monthly-pension-${customerId}`} className="col-sm-8 col-form-label">
                            Mánaðarlegur tekjulífeyrir
                            {this.state.errors.monthlypension.length > 0 ?
                                 <span className="error"> ({this.state.errors.monthlypension}) </span> : ''
                            }
                        </label>
                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat 
                                ref={this.monthlypension}
                                thousandSeparator={"."} 
                                id={`ris-monthly-pension-${customerId}`} 
                                name="RISmonthlypension" 
                                type="text" 
                                className="form-control text-sm-right pr-4"                               
                                value={initialValues["RISmonthlypension"]} 
                                disabled={initialValues.risConfirm}
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.onChangeLargeNumberInput(value, "RISmonthlypension")
                                }}
                            />
                            250-3.000 €
                        </div>
                    </div>
                    <div className="form-row align-items-center">
                        <div className="col-sm-8">
                            <label htmlFor={`ris-payment-frequency-${customerId}`} className="col-sm-8 col-form-label pl-0">Greiðslutíðni</label>
                        </div>
                        <div className="col-sm-4 text-right">
                            <select className="custom-select col-sm-4" id={`ris-payment-frequency-${customerId}`} name="RISpaymentfrequency" onChange={this.onChangeSelectValue} value={initialValues["RISpaymentfrequency"]} disabled={initialValues.risConfirm} >
                                <option value="monthly">Mánaðarlega</option>
                                <option value="quarterly">Ársfjórðungslega</option>
                                <option value="every6months">Hálfsárslega</option>
                                <option value="yearly">Árlega</option>
                               
                            </select>
                        </div>
                    </div>
                    <InsuranceTaker 
                        fieldName={`RISinsuranceTaker`} 
                        customerId={customerId} 
                        customers={customers} 
                        initialValues={initialValues}
                        ref={this.insurancetaker} 
                        errors={this.state.errors.insurancetaker}
                        disabled={initialValues.risConfirm}
                    />
                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.risConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="risConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="risConfirm" onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default RisForm